import { Injectable } from "@angular/core";
import { BaseDataService, HttpService } from "./base.service";
import { SourceCode } from "../..";

@Injectable()
export class SourceCodeService extends BaseDataService<SourceCode> {
  constructor(http: HttpService) {
    super(http, "sourcecode");
  }

  createInstance(options: any): SourceCode {
    return new SourceCode(options);
  }

  getActive() {
    return this.http.request(`${this.resourceUrl}/active`);
  }
}
